import { calcPersent } from "../../fundraising/utils";
import { SOUVENIRS_LIST, CREATED_STATUSES } from "../constants";
import styles from "./styles.module.scss";

const SouvenirsList = ({
  status,
  souvenirs,
}: {
  status: string;
  souvenirs: Record<string, any>;
}) => {
  return (
    <div className={styles.SouvenirsList}>
      {SOUVENIRS_LIST.map((souvenir) => (
        <div className={styles.Souvenir} key={souvenir.id}>
          <div className={styles.Souvenir_img}>
            <img src={souvenir.img} alt={souvenir.name} />
          </div>
          <p className={styles.Souvenir_name}>{souvenir.name}</p>

          {status !== 'auth' && (
            souvenirs[`${souvenir.codeName}`]?.received ? (
              // Если сувенир получен, показываем дату получения
              <p className={styles.Souvenir_progress__status}>
                Получен {souvenirs[`${souvenir.codeName}`]?.received?.slice(0, 10)?.split('-')?.reverse()?.join('.')}
              </p>
            ) : (
              // Если сувенир не получен
              souvenirs[`${souvenir.codeName}`]?.progress === souvenirs[`${souvenir.codeName}`]?.progress_limit && CREATED_STATUSES.includes(status) ? (
                // Если статус в CREATED_STATUSES и прогресс равен лимиту, показываем "Готовится к отправке"
                <p className={styles.Souvenir_progress__status}>
                  Готовится к отправке
                </p>
              ) : (
                // Иначе показываем прогресс бар и статус
                <div className={styles.Souvenir_progress}>
                  <div>
                    <span
                      style={{
                        width: `${calcPersent(String(souvenirs[`${souvenir.codeName}`]?.progress), String(souvenirs[`${souvenir.codeName}`]?.progress_limit))}%`,
                      }}
                    ></span>
                  </div>
                  <p className={styles.Souvenir_progress__status}>
                    {souvenirs[`${souvenir.codeName}`]?.progress === souvenirs[`${souvenir.codeName}`]?.progress_limit
                      ? 'Доступен к получению'
                      : 'Не выполнены все условия'}
                  </p>
                  {/* Отображаем счетчик прогресса всегда, если прогресс не равен лимиту */}
                  {souvenirs[`${souvenir.codeName}`]?.progress !== souvenirs[`${souvenir.codeName}`]?.progress_limit && (
                    <p className={styles.Souvenir_progress__count}>
                      {souvenirs[`${souvenir.codeName}`]?.progress} из {souvenirs[`${souvenir.codeName}`]?.progress_limit}
                    </p>
                  )}
                </div>
              )
            )
          )}
        </div>
      ))}
    </div>
  );
};

export default SouvenirsList;